import { ApolloClient, InMemoryCache, createHttpLink, split } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getMainDefinition } from "@apollo/client/utilities";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

import { storageHelper } from "lib/helpers";
import config from "configuration";

const authLink = setContext((request, { headers }) => {
  const token = storageHelper.get("token") || "";
  return {
    headers: {
      ...headers,
      token,
    },
  };
});
const httpLink = createHttpLink({
  uri: config.apiURL,
});

// Create a WebSocket link:
const wsLink = new GraphQLWsLink(
  createClient({
    url: config.webSocketUrl,
    connectionParams: () => ({
      token: storageHelper.get("token") || "",
    }),
    retryWait: async (retries) => {
      const maxWait = 5000;
      const wait = Math.min(100 * retries, maxWait);
      return wait;
    },
    shouldRetry: (errOrCloseEvent) => true,
    lazy: true,
  })
);

const newLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
  },
  wsLink,
  authLink.concat(httpLink)
);

const cache = new InMemoryCache({
  addTypename: false,
  typePolicies: {
    Query: {
      fields: {
        isLoggedIn: {
          read() {
            return isLoggedInVar();
          },
        },
        user: {
          read() {
            return userVar();
          },
        },
      },
    },
  },
});

const client = new ApolloClient({
  cache,
  link: newLink,
  resolvers: {},
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "network-only",
    },
    query: {
      fetchPolicy: "network-only",
    },
    mutate: {
      fetchPolicy: "no-cache",
    },
  },
  fetchOptions: {
    mode: "no-cors",
  },
});

export default client;
